import {
  getPublicAuthHeader,
  getReturnWidgetBaseUrl,
} from "@babackapp/private-api-client/client/return-widget-client";

// BBS-237 follow-up: no telemetry existed for widget v2's step transitions
// and payment attempts, so a missing complement payment was only ever
// discovered weeks later via manual DB audit. Fire-and-forget by design —
// a telemetry failure must never surface to the customer or interrupt the
// actual return/exchange flow. Uses `orderId` as the correlation key: this
// widget has no separate checkout-session token concept (drafts are keyed
// by orderId already).
export function trackWidgetEvent(params: {
  shopId: string;
  orderId: string;
  eventType: string;
  payload?: Record<string, unknown>;
}): void {
  const { shopId, orderId, eventType, payload } = params;

  const authHeader = getPublicAuthHeader();
  // No session token yet (e.g. before the order session is established) —
  // the backend would reject it anyway (no token to match against orderId),
  // so skip the request instead of firing it needlessly.
  if (!authHeader.authorization || authHeader.authorization === "Bearer ") {
    return;
  }

  const base = getReturnWidgetBaseUrl().replace(/\/$/, "");
  fetch(`${base}/public/return-request/telemetry`, {
    method: "POST",
    headers: {
      ...authHeader,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    credentials: "omit",
    body: JSON.stringify({
      shopId,
      orderId,
      checkoutToken: orderId,
      eventType,
      payload,
    }),
  }).catch((e) => {
    console.debug("[trackWidgetEvent] failed to send", eventType, e);
  });
}
